export default __webpack_public_path__ + "locales/ru/SendInviteDialog.json?hash=c385cdfd2433537133b930eda38b144e";